import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectLawFirm } from "../../../../lib/fetchApi"
import Button from "../../../common/Button"
import SelectWithLabelAsync from "../../../common/SelectWithLabelAsync"
import { notificationActions } from "../../../../store/notifications"
import { attorneyActions } from "../../../../store/attorneys"
import AttorneysSearchDone from "./AttorneysSearchDone"
import AsignAttorney from "./AsignAttorney"
import CreateLawFirm from "./CreateLawFirm"

import classes from './AttorneyTabControls.module.css'
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
// import CustomSelectAsyncSingle from "../../../common/interactive/CustomSelectAsyncSingle"

const AttorneyTabControls = ({apiCase}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(apiCase + '_assign')
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const [searchedAsyncValue, setSearchedAsyncValue] = useState(null)
    // const [searchResult,setSearchResults] = useState(null)
    // const [searchPath,setSearchPath] = useState(null)
    
  
    const isSearched = useSelector(state => state.attorney.searchResult)

    const searchLawFirmhandler = async (data) => {
        setSearchedAsyncValue(data)
        const lowFirm = await selectLawFirm(userToken, data.value)
        // const lowFirm = await selectLawFirm(userToken, data.data.value)

        if (lowFirm.status) {
            dispatch(notificationActions.setError(lowFirm))
        } else {
            // setSearchPath(data.path)
            // setSearchResults(lowFirm)
            dispatch(attorneyActions.setSearchResult(lowFirm))
        }
    }

    const clearFieldsHandler = () => {
        dispatch(attorneyActions.setSearchResult(null))
        dispatch(attorneyActions.setClearAsyncResults(true))

        dispatch(attorneyActions.removeFirmLocationAttorneySelection())
    }   
    

    return <div className={classes.controls}>        
        
        {!userPermissionDisabled && <>

            

            {/* {!isSearched && <div className={classes.async_container}>
                <CustomSelectAsyncSingle label={'Low Firm'} path={'law-firms'} action={searchLawFirmhandler} maxWidth={165} minWidth={160} />

                <CustomSelectAsyncSingle label={'Location'} path={'law-firm-locations'} action={searchLawFirmhandler} maxWidth={165} minWidth={160} />

                <CustomSelectAsyncSingle label={'Atty name'} path={'law-firm-attorneys'} action={searchLawFirmhandler} maxWidth={165} minWidth={160} />
            </div>}

            {isSearched && <>
                <AttorneysSearchDone searchedData={searchedAsyncValue} path={searchPath}/>
            </>} */}
     

            {!isSearched && <div className={classes.async_container}>
                <SelectWithLabelAsync label='Low Firm' path={'law-firms'} action={searchLawFirmhandler} maxWidth={220} minWidth={200}/>
                <SelectWithLabelAsync label={'Location'} path={'law-firm-locations'} action={searchLawFirmhandler} maxWidth={165} minWidth={160}/>
                <SelectWithLabelAsync label={'Atty name'} path={'law-firm-attorneys'} action={searchLawFirmhandler} maxWidth={165} minWidth={160}/>
            </div>}

            {isSearched && <>
                <AttorneysSearchDone searchedData={searchedAsyncValue}/>
            </>}

            <Button btnStyle={'btn_light_grey'} click={clearFieldsHandler} title={'Clear'}><i className="ti ti-x"></i></Button>
            <AsignAttorney/>
        </>}

        <CreateLawFirm permission={'create_attorney'}/>
    </div>
}

export default AttorneyTabControls